var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-377.000000, -3855.000000)",
    fill: "#248138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Checklist",
    transform: "translate(356.000000, 3544.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1.1,
    transform: "translate(21.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,6.63 C16.6568499,6.63 18,7.97315 18,9.63 L18,9.63 L18,21.63 C18,23.28685 16.6568499,24.63 15,24.63 L15,24.63 L3,24.63 C1.34315,24.63 0,23.28685 0,21.63 L0,21.63 L0,9.63 L0,9.63 L0.00509270909,9.45372768 C0.0963394133,7.87892434 1.40232321,6.63 3,6.63 L3,6.63 Z M15.0000001,8.6300006 L3.00000009,8.6300006 C2.44771509,8.6300006 2.00000009,9.0777156 2.00000009,9.6300006 L2.00000009,9.6300006 L2.00000009,21.6300006 L2.00000009,21.6300006 L2.00672782,21.7466217 C2.06449289,22.2439605 2.48716402,22.6300006 3.00000009,22.6300006 L3.00000009,22.6300006 L15.0000001,22.6300006 C15.5522851,22.6300006 16.0000001,22.1822855 16.0000001,21.6300006 L16.0000001,21.6300006 L16.0000001,9.6300006 C16.0000001,9.0777156 15.552285,8.6300006 15.0000001,8.6300006 L15.0000001,8.6300006 Z M11.7727497,11.9244029 C12.1228895,11.5675822 12.692159,11.5190214 13.1000002,11.8300005 C13.5418282,12.1668905 13.6268942,12.7981725 13.2900002,13.2400005 L13.2900002,13.2400005 L8.72000021,19.2400005 C8.53120721,19.4852475 8.23949721,19.6292566 7.93000021,19.630015 L7.93000021,19.630015 L7.79934289,19.6221552 C7.54101616,19.5895432 7.30356187,19.4569936 7.14000016,19.2500005 L7.14000016,19.2500005 L4.71000016,16.1400005 L4.71000016,16.1400005 L4.63901111,16.0361128 C4.38451708,15.6086324 4.48225708,15.0485282 4.88500016,14.7350005 C5.32130516,14.3953455 5.95034516,14.4736955 6.29000016,14.9100005 L6.29000016,14.9100005 L7.92000013,17.0200005 L11.7000001,12.0200005 L11.6900002,12.0200005 L11.6900002,12.0200005 Z",
    id: "Fill"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageTick);
export default __webpack_public_path__ + "static/media/pageTick.faa592a6e43cf9d5fbc4996f83370a21.svg";
export { ForwardRef as ReactComponent };